export default __webpack_public_path__ + "static/media/16.6e8ee9d6.jpg";